import { useUser } from '@/contexts/AuthContext';
import { InfoOutlined, ExpandMore } from '@mui/icons-material';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from '@mui/material';

export default function PendingApproval() {
  const { defaultMembership } = useUser();

  const hasRequestedValidation =
    defaultMembership?.has_requested_validation &&
    !defaultMembership.is_validated &&
    !defaultMembership.is_refused;

  return (
    <>
      {hasRequestedValidation && (
        <Accordion
          sx={{
            backgroundColor: 'warning.light',
            borderRadius: '12px !important',
            mb: 3,
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMore sx={{ color: 'warning.dark' }} />}
          >
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <InfoOutlined sx={{ color: 'warning.dark' }} />
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  color: 'warning.dark',
                  ml: 1,
                }}
              >
                <Typography sx={{ fontWeight: '500' }} variant="body1">
                  {defaultMembership?.company.full_name}
                </Typography>
                <Typography sx={{ fontWeight: '300' }} variant="body2">
                  Pendente de aprovação do(s) administrador(es)
                </Typography>
              </Box>
            </Box>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              color: 'warning.dark',
              ml: 4,
              mt: -1,
            }}
          >
            <Typography variant="body2" sx={{ fontWeight: '400' }}>
              Seu usuário está pendente de aprovação do(s) administrador(es) da
              empresa que você representa.
            </Typography>
          </AccordionDetails>
        </Accordion>
      )}
    </>
  );
}
